{
  "__GENERATED__": "WARNING: This file is generated from 'resourceBlocklist.yaml'. DO NOT EDIT.",
  "protocolAllowlist": [
    "https",
    "http"
  ],
  "blockedUrlPrefixes": {
    "ignore": [
      "aa.agkn.com/adscores/g.pixel",
      "action.dstillery.com/orbserv",
      "ad.360yield.com/match",
      "ad.doubleclick.net/ddm",
      "ade.clmbtech.com/uid/",
      "ads.scorecardresearch.com/b",
      "ads.sparkflow.net/e/",
      "ads.stickyadstv.com/user-registering",
      "ads.undertone.com/l",
      "ads.us.e-planning.net",
      "ads.yahoo.com/cms/v1",
      "ads.yieldmo.com/v000",
      "analytics.twitter.com/i/adsct",
      "analytics.twitter.com/1/i/adsct",
      "api.adsymptotic.com/api/s/trackconversion",
      "api.sfnix.net/api/tracker",
      "app.comeet.co/api/v1/",
      "app.eu.pendo.io/data/",
      "app.pendo.io/data/",
      "app01.us.bill.com/is/",
      "app02.us.bill.com/is/",
      "apt.techtarget.com/activity",
      "b.criteo.com/beacon",
      "bat.bing.com",
      "bat.r.msn.com",
      "beacon.flow.io/events/pageview",
      "beacon.flow.io/events/session_upserted",
      "beacon.krxd.net",
      "bh.contextweb.com",
      "billyjons.net/metric/",
      "bm.adentifi.com/pixel",
      "bs.nakanohito.jp/ua/",
      "bttrack.com/Pixel",
      "cdn.bizible.com/m",
      "ci.iasds01.com/",
      "click.appcast.io",
      "cm.everesttech.net/cm/",
      "cm.g.doubleclick.net/pixel",
      "cnv.event.prod.bidr.io/log/cnv",
      "compare.spirit.com/pixel.php",
      "connect.facebook.net",
      "consent.linksynergy.com/consent/",
      "conv.indeed.com/pagead/conv",
      "cs.choozle.com/dp",
      "ct.pinterest.com/v3/",
      "cw.addthis.com/t.gif",
      "d.adroll.com",
      "d.agkn.com/pixel/",
      "d3accju1t3mngt.cloudfront.net/css/guide.css",
      "data.adxcel-ec2.com/pixel/",
      "data.eu.pendo.io/data/",
      "data.pendo.io/data/",
      "data.photorank.me/track",
      "data.tagdelivery.com/sap/impression",
      "dc.ads.linkedin.com/collect/",
      "dp.shoprunner.com/i",
      "dpm.demdex.net",
      "dsum-sec.casalemedia.com/rum",
      "eb2.3lift.com/xuid",
      "edgepro.gatewaypn.com/assets/pages/media/bg/road.jpg",
      "edgepro.gatewaypn.com/font/proximanova-",
      "event.havasedge.com/track-event",
      "exchange-match.mediaplex.com/sync",
      "fdz.flashtalking.com/services/lowes/FBI-2422_segment/",
      "flightdeck.staples.com/styles/img/blank.gif",
      "fs-excluded.invalid",
      "fs-obfuscated.invalid",
      "go.servicetitan.com/Attach/Preview",
      "googleads.g.doubleclick.net",
      "gum.criteo.com",
      "h.online-metrix.net",
      "hardyload.com/metric/",
      "heapanalytics.com/h",
      "hit.8digits.com",
      "hits.livemarketshoppers.com",
      "i.liadm.com/s",
      "idsync.rlcdn.com",
      "ifm.fmpilot2.com/DXR.axd",
      "image.apartmentguide.com/imgr",
      "image.rent.com/imgr",
      "image.rentals.com/imgr",
      "image1.apartmentguide.com/imgr",
      "image1.rent.com/imgr",
      "image1.rentals.com/imgr",
      "img.zumpercdn.com",
      "imp-alert.katch.com/track/pixel.php",
      "insight.adsrvr.org/track/",
      "kds-pixel.kargo.com/api/v1/track",
      "lciapi.ninthdecimal.com/v1/lci/imp/adv-smg/c-22568",
      "login.dotomi.com/ucm/UCMController",
      "lowes.netmng.com/pixel/",
      "match.adsrvr.org/track/cmf/generic",
      "msh.mckesson.com/ehr/rest/",
      "msh.mckesson.com/ehr/gwtrpc/",
      "msh.mckesson.com/ehr/gwtRequest/",
      "nbcu.demdex.net/event",
      "new-collect.albacross.com",
      "nexus.ensighten.com",
      "nova.collect.igodigital.com",
      "nyl.as",
      "p.rfihub.com/cm",
      "pagead2.googlesyndication.com/pagead/gen_204",
      "partner.mediawallahscript.com/",
      "ping.chartbeat.net",
      "pippio.com/api/sync",
      "pixel-geo.prfct.co/cs/",
      "pixel-geo.prfct.co/seg/",
      "pixel.advertising.com/ups/",
      "pixel.clutter.com/wt/track.gif",
      "pixel.locker2.com",
      "pixel.mathtag.com",
      "pixel.rubiconproject.com/tap.php",
      "pixel.tapad.com/idsync/ex/receive",
      "pl.yext.com/plpixel",
      "ps.mythirtyone.com/31Designer/tools/GetTemplatePreview2",
      "pt.ispot.tv",
      "pubads.g.doubleclick.net/activity",
      "px.ads.linkedin.com/collect",
      "px.marchex.io/pixel.gif",
      "px.owneriq.net/ep",
      "px.owneriq.net/eucm/p/sig",
      "px0.pbbl.co/ns/",
      "q.quora.com/_/ad/",
      "r.casalemedia.com",
      "r.turn.com/r/beacon",
      "rp.liadm.com/p",
      "rt3015.infolinks.com/action/",
      "rtb-csync.smartadserver.com/redir",
      "s-vop.sundaysky.com/t",
      "s.amazon-adsystem.com/iui3",
      "s.ml-attr.com/getuid",
      "saffron.760main.com/atc/cvi",
      "saffron.760main.com/atc/ofi",
      "saffron.760main.com/atc/pgi",
      "saffron.760main.com/imp",
      "sb.scorecardresearch.com/p",
      "secure.adnxs.com",
      "secure.converto.com/img",
      "secure.media6degrees.com/orbserv/hbpix",
      "securepubads.g.doubleclick.net/pcs/view",
      "segment.prod.bidr.io/associate-segment",
      "servedby.flashtalking.com/spot",
      "shareasale-analytics.com/j.js",
      "shareasale-analytics.com/sale.cfm",
      "shareasale.com/sale.cfm",
      "shop.pe/widget/main/bt_view/params",
      "simage2.pubmatic.com",
      "sp.analytics.yahoo.com",
      "srv.stackadapt.com/rt",
      "ssp.meba.kr/cm.mezzo",
      "starman.fathomdns.com",
      "static.criteo.net/images/pixel.gif",
      "stats.g.doubleclick.net",
      "streams.gong.io/stream/request/proxy",
      "sync-criteo.ads.yieldmo.com/sync",
      "sync.aralego.com/idSync",
      "sync.e-planning.net/um",
      "sync.outbrain.com/cookie-sync",
      "t.co/i/adsct",
      "t.co/1/i/adsct",
      "t.indeed.com/fullstory/log",
      "t.myvisualiq.net/activity_pixel",
      "t.teads.tv/track",
      "t.wepay.com/fp/clear.png",
      "tag.rmp.rakuten.com",
      "tags.bluekai.com/site/",
      "tags.w55c.net/rs",
      "tapestry.tapad.com/tapestry/1",
      "telem.highlow.net",
      "texasroadhouse.alohaorderonline.com/DXR.axd",
      "tl.r7ls.net",
      "track.customer.io/events/",
      "track.hubspot.com",
      "track.linksynergy.com",
      "trackingapi.trendemon.com",
      "trk.clinch.co/sync",
      "trkn.us/pixel/c",
      "txcontent.iherb.com",
      "urldefense.com",
      "urldefense.proofpoint.com/v2/url",
      "ut.ra.linksynergy.com",
      "vidassets.terminus.services",
      "webanalytics.lexisnexis.com",
      "widget.criteo.com/event",
      "widgets.magasins.labaie.com/cookies/render",
      "widgets.stores.saks.com/cookies/render",
      "widgets.stores.saksfifthavenue.com/cookies/render",
      "widgets.stores.thebay.com/cookies/render",
      "wpromote-7-adswizz.attribution.adswizz.com/fire",
      "www.adelixir.com",
      "www.bellacasino.com/games/launch/",
      "www.facebook.com/tr",
      "www.fmpilot2.com/DXR.axd",
      "www.globalgiving.org/pfil",
      "www.google-analytics.com/collect",
      "www.google-analytics.com/r/collect",
      "www.google.co.th/pagead/1p-user-list/",
      "www.google.com/ads/ga-audiences",
      "www.google.com/ads/measurement/",
      "www.google.com/pagead/1p-user-list/",
      "www.googleadservices.com",
      "www.googletagmanager.com/a",
      "www.grosvenorcasinos.com/games/launch/",
      "www.justfly.com/checkout/get-profiling-tags",
      "www.linkedin.com/csp/cat",
      "www.magicalvegas.com/games/launch/",
      "www.meccabingo.com/games/launch/",
      "www.ojrq.net/p/",
      "www.shareasale-analytics.com/j.js",
      "www.shareasale-analytics.com/sale.cfm",
      "www.shareasale.com/sale.cfm",
      "www.thezebra.com/be/i/t/",
      "www.uswitch.com/sif/",
      "www18.officedepot.com/eluminate",
      "x.bidswitch.net/sync",
      "zoudlogick.net",
      "secure-www.gap.com/shopping-bag?",
      "secure-www.gapcanada.ca/shopping-bag?",
      "secure-oldnavy.gap.com/shopping-bag?",
      "secure-bananarepublicfactory.gapfactory.com/shopping-bag?",
      "secure-www.gapfactory.com/shopping-bag?",
      "secure-bananarepublic.gap.com/shopping-bag?",
      "secure-oldnavy.gapcanada.ca/shopping-bag?",
      "secure-athleta.gap.com/shopping-bag?",
      "fs.invalid/test#testHash",
      "fs.invalid/test?withQs#withHash"
    ],
    "localFallback": [
      "localhost",
      "image.s5a.com/is/image/saksoff5th/",
      "delivery.panerabread.com/fonts/",
      "static2.sharepointonline.com/files/fabric/assets/fonts/",
      "www-beta.panerabread.com/content/dam/panerabread/static/fonts/",
      "www-beta.panerabread.com/fonts/",
      "www.panerabread.com/fonts/",
      "ilunafriq.com/design/",
      "fs-currenturl.invalid",
      "virtualmedia.bentleymotors.com/"
    ],
    "proxy": [
      "drscdn.org.500px/photo/",
      "fonts.googleapis.com"
    ]
  },
  "blockedDomains": {
    "ignore": [
      [
        "*",
        "*",
        "*",
        "awstrack",
        "me"
      ],
      [
        "*",
        "*",
        "*",
        "online-metrix",
        "net"
      ],
      [
        "*",
        "*",
        "adition",
        "com"
      ],
      [
        "*",
        "agileone",
        "com"
      ],
      [
        "*",
        "agilone",
        "com"
      ],
      [
        "*",
        "baynote",
        "net"
      ],
      [
        "*",
        "bmetrack",
        "com"
      ],
      [
        "*",
        "clouddn",
        "com"
      ],
      [
        "*",
        "convertlab",
        "com"
      ],
      [
        "*",
        "d",
        "aa",
        "online-metrix",
        "net"
      ],
      [
        "*",
        "dc-storm",
        "com"
      ],
      [
        "*",
        "micpn",
        "com"
      ],
      [
        "*",
        "openx",
        "net"
      ],
      [
        "*",
        "saas",
        "seewhy",
        "com"
      ],
      [
        "*",
        "silverpop",
        "com"
      ],
      [
        "*",
        "taboola",
        "com"
      ],
      [
        "ad",
        "tagdelivery",
        "com"
      ],
      [
        "adtrack",
        "hulu",
        "com"
      ],
      [
        "h",
        "online-metrix",
        "net"
      ],
      [
        "imgs",
        "signifyd",
        "com"
      ],
      [
        "px",
        "a8",
        "net"
      ],
      [
        "tracking",
        "g2crowd",
        "com"
      ],
      [
        "udc-neb",
        "kampyle",
        "com"
      ],
      [
        "auth",
        "grin",
        "co"
      ]
    ],
    "localFallback": [
      [
        "cdn",
        "bibliu",
        "com"
      ],
      [
        "cdn",
        "f",
        "thread",
        "com"
      ],
      [
        "images",
        "gcp",
        "thread",
        "com"
      ],
      [
        "storage",
        "thread",
        "com"
      ],
      [
        "static",
        "thread",
        "com"
      ]
    ],
    "proxy": []
  },
  "blockedSubstrings": {
    "ignore": [
      "not supported by Safari"
    ],
    "localFallback": [
      "resources/fonts/Alegreya/Alegreya-Italic.ttf",
      "resources/fonts/Quattrocento/Quattrocento-Regular.ttf",
      "resources/fonts/Quattrocento_Sans/QuattrocentoSans-Regular.ttf"
    ],
    "proxy": []
  },
  "blockedRegexps": {
    "ignore": [
      "^forms\\.storefrontloans\\.com/.*lead/pixel/.*",
      "^manage\\.rewardsgenius\\.com/font/proximanova-.*\\.(?:eot|eot?|svg|ttf|woff|woff2)",
      "^manage\\.rewardsgenius\\.com/fonts/inter/.*\\.woff2",
      "^manage\\.rewardsgenius\\.com/fonts/materialdesignicons-.*\\.(?:eot|eot?|ttf|woff)",
      "^manage\\.rewardsgenius\\.com/fonts/tc-icons.*\\.(?:eot?|ttf|woff|woff2)",
      "^static\\.nationwide\\.com/app/clicktochat/application/version/pie_files/PIE\\.htc",
      "^(pt-)*static\\.nationwide\\.com/fonts/ChronicleTextG1-(?:Bold|Italic|Roman)\\.(?:eot|ttf|woff)",
      "^(pt-)*static\\.nationwide\\.com/fonts/ProximaNova-(?:Bold_gdi|Light_gdi|Regular_gdi)\\.(?:eot|ttf|woff|svg)",
      "^(pt-)*static\\.nationwide\\.com/media/bolt-icons\\.(?:eot|ttf|woff|svg)",
      "^edgepro\\.gatewaypn\\.com/images/ui-icons_(?:.){6}_256x240\\.png",
      "^edgepro\\.gatewaypn\\.com/fonts/inter/Inter-UI-(?:Black|MediumItalic|Medium|Italic|Regular|Bold|BlackItalic|BoldItalic)\\.woff",
      "^edgepro\\.gatewaypn\\.com/fonts/dynamics_icon_.*\\.(?:eot|ttf|woff|woff2)",
      "^edgepro\\.gatewaypn\\.com/images/dynamics_icon_.*\\.svg",
      "^edgepro\\.gatewaypn\\.com/assets/images/(arrow-dark-mode\\.png|arrow-light-mode\\.png|arrow-light-mode-up\\.png|circle_2\\.svg|x\\.png|arrow-dark-mode-up\\.png|loading\\.gif|clockify_logo_dark\\.svg|circle_1\\.svg)",
      "^edgepro\\.gatewaypn\\.com/Content/plugins/datatables/images/sort_(?:desc|asc|both)(?:_disabled)?\\.png",
      "^book\\.jetblue\\.com/B6/pictures/misc/(?:x|true-blue-block-sep|bg-total-price-separator|form_sep)?\\.gif",
      "^cdn-us-ec\\.yottaa\\.net/.*trans2\\.png",
      "^fyf\\.tac-cdn\\.net/images/layout.*/nav_.*\\.png",
      "^.*ib\\.adnxs\\.com",
      "^static-awsblue-prodxenial\\.minted\\.com/.*sprite_placeholder.png",
      "^cdn\\.shopify\\.com/.*(google-review_1x|placeholder)\\.png",
      "^cdn\\.shopify\\.com/.*blank\\.gif",
      "^lda\\.lowes\\.com/.*Dot0x000000opacity75",
      "^www\\.rev\\.com/.*one-pixel\\.png",
      ".*/seteventid\\.png",
      "^tbc.scene7.com/is/image/TBCCorporation/kat-blank",
      "^deviceprotection\\.phoneclaim\\.com/.*\\.eot\\??",
      ".*\\.biglots\\.com/profile/set/fpc/px",
      ".*\\.kaspersky-labs\\.com/.*",
      ".*SBExtension.browserInject.getURL.*",
      "^inqjal\\.dickssportinggoods\\.com/g/uids.*",
      "^msh\\.mckesson\\.com/ehr/.*\\.jsp"
    ],
    "localFallback": [
      "^([^.]+\\.)?bibliu.com/books/.*",
      "^([^.]+\\.)?bibliotech.(com|education)/books/.*",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/2/resources/css/ic-client-validation-ADA.css",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/2/resources/plugins/bootstrap/bootstrap.css",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/2/resources/plugins/datatables/buttons.dataTables.min.css",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/2/resources/plugins/datepicker/datepicker.min.css",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/2/resources/plugins/fonts/googleFonts.css",
      "^www.invoicecloud.com/portal/\\(S(.*)\\)/branding/themes/ICBlue/themeStyle.css",
      "^.*\\.newspapers\\.com/img/.*"
    ],
    "proxy": []
  },
  "tests": {
    "ignore": [
      "about:blank",
      "chrome-extension://asdasdasdasdaasd",
      "http://ad.tagdelivery.com/impression?id=115fb25e-8845-4c97-93e6-654e5afef8d3",
      "http://ads.us.e-planning.net/eb/1/12345/Impresion/Bottom_Banner_1_Impresion?o=i&rnd=$RANDOM",
      "http://bat.bing.com/action/0?ti=40152111",
      "http://bat.r.msn.com/action-uic/0?ti=4015238&Ver=2",
      "http://ca-as-1.agilone.com/im.gif?bid=3&bar=alog%3A10000001%26Ns%3Dprop_Bestse",
      "http://d3accju1t3mngt.cloudfront.net/css/guide.css?ct=1485792797280",
      "http://d3accju1t3mngt.cloudfront.net/css/guide.css?ct=9494949494949",
      "http://kckt9wlk.r.eu-west-1.awstrack.me/I0/GUID/STRING=210",
      "http://tl.r7ls.net/fl/?d=%7Bacc:%2248706%22,sd:57,t:%5B%7Bid:171",
      "https://aa.agkn.com/adscores/g.pixel",
      "https://abandonment6.saas.seewhy.com:443/abandonment2/WE/seewhy.nogif/0.2306963065704004?Event=WebEvent",
      "https://ad.doubleclick.net/ddm/activity/src=XXX;type=sales;cat=XXX;qty=1;cost=0;u1=;u16=;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=[OrderID]",
      "https://ad.tagdelivery.com/any-other-path",
      "https://ad.tagdelivery.com/impression?id=115fb25e-8845-4c97-93e6-654e5afef8d3",
      "https://ad.tagdelivery.com/impression?id=blah-blah",
      "https://ad11.adfarm1.adition.com/tagging?type=image&network=ID&tag[ID]=NUMBER",
      "https://ads.stickyadstv.com/user-registering?dataProviderId=NUMBER&userId=ID",
      "https://ams1-ib.adnxs.com",
      "https://analytics.twitter.com/i/adsct",
      "https://analytics.twitter.com/1/i/adsct",
      "https://api.sfnix.net/api/tracker?url=URL&source=&time=TIMESTAMP",
      "https://apt.techtarget.com/activity/activity.gif?activityTypeId=ID&cid=ID&version=V&ref=URL&r=NUMBER",
      "https://b.criteo.com/beacon",
      "https://beacon.flow.io/events/pageview",
      "https://beacon.flow.io/events/session_upserted",
      "https://beacon.krxd.net/pixel.gif?source=smarttag&fired=report",
      "https://bh.contextweb.com/bh/rtset?pid=ID&ev=NUMBER&rurl=URL&userid=ID&gdpr=true&gdpr_consent=",
      "https://bm.adentifi.com/pixel/conv/ppt=XXX;g=thank_you_page_jfk_to_psp_2019;gid=XXX;ord=[uniqueid]",
      "https://bs.nakanohito.jp/ua/",
      "https://bttrack.com/Pixel/Conversion/15499/sitevisit?type=img",
      "https://cbe.convertlab.com/cbe/__utm?utma=1099651369.83494750.1594592170861590970.1616035426.1616035794.79&utmb=1099651369.83494750.1616035794.1616039484.16&token=1099651369.83494750&tenantId=1594592170861590970&event=c_init_database&targetName=%E5%B7%A5%E4%BD%9C%E7%A9%BA%E9%97%B4%20-%20%E6%99%BA%E6%85%A7%E8%8A%BD&targetId=1576049572&pageId=1576049572&screenWidth=1920&screenHeight=1080&pageType=web&identityType=c_patsnap&identityValue=VEW1ZaM0FFBgHGTS5lGm7A%3D%3D&refDomain=analytics.zhihuiya.com&hosting=web",
      "https://cdn.shopify.com/s/files/1/0078/6825/2273/files/google-review_1x.png?v=1591619027",
      "https://cdn.shopify.com/s/files/1/0078/6825/2273/t/790/assets/placeholder.png?v=10482267166085586573",
      "https://cdn.shopify.com/s/files/1/1296/1129/t/2/assets/blank.gif?v=16482679876569321596",
      "https://ci.iasds01.com/",
      "https://click.appcast.io/generic-te8/a31.png?r=URL&jid=ID&tn=ID&rn=ID&e=NUMBER&ent=NUMBER&pu=URL",
      "https://clt1129506.bmetrack.com/c/o?e=ID&c=ID&t=NUMBER&l=ID&email=EMAIL&relid=",
      "https://cm.g.doubleclick.net/pixel",
      "https://cnv.event.prod.bidr.io/log/cnv",
      "https://compare.spirit.com/pixel.php",
      "https://connect.facebook.net",
      "https://conv.indeed.com/pagead/conv/ID/?script=0",
      "https://cs.choozle.com/dp/chz/ID?d=DOMAIN&cb=ID",
      "https://ct.pinterest.com/v3/",
      "https://d.agkn.com/pixel/10106/",
      "https://d.agkn.com/pixel/8544/",
      "https://d.agkn.com/pixel/9043/",
      "https://d.agkn.com/pixel/9458/",
      "https://d3accju1t3mngt.cloudfront.net/css/guide.css?ct=1485792797280",
      "https://data.adxcel-ec2.com/pixel/",
      "https://data.photorank.me/track/widget/ID/stream/ID/render.gif?analytics_id=ID&pics=NUMBER&auth_token=ID&trand=NUMBER",
      "https://data.tagdelivery.com/sap/impression?impression_id=SOME_GUID&sap=SOME_GUID",
      "https://dc.ads.linkedin.com/collect/",
      "https://dsum-sec.casalemedia.com/rum",
      "https://engage1.silverpop.com/cst?m=10711111596&j=48",
      "https://engage5.silverpop.com/cst?m=10711111596&j=48",
      "https://event.havasedge.com/track-event?emeta=DATA&trkGuid=GUID&evtGuid=GUID&data-user_id=GUID",
      "https://exchange-match.mediaplex.com/sync/px/1?networkId=NUMBER&dtm_token=TOKEN",
      "https://fdz.flashtalking.com/services/lowes/FBI-2422_segment/",
      "https://fra1-ib.adnxs.com",
      "https://h.online-metrix.net",
      "https://h.online-metrix.net/fp/clear.png?%5Bother-stuff",
      "https://hit.8digits.com/setpageattrs?trackingCode=CODE&visitorCode=GUID&sessionCode=GUID&obj=DOMAIN&domain=DOMAIN&path=PATH&hitCode=NUMBER&rnd=NUMBER",
      "https://hits.livemarketshoppers.com/fullthrottlelims_pxl.gif?c=ID&r=ID&f=URL&b=USERAGENT&l=en-us&p=URL&s=NUMBER&hs=&ss=NUMBER&ly=NUMBER&z=NUMBER",
      "https://ib.adnxs.com/getuid",
      "https://ib.adnxs.com/seg?add=22136226",
      "https://ib.adnxs.com/setuid",
      "https://idsync.rlcdn.com/123456.gif?partner_uid=GUID",
      "https://ifm.fmpilot2.com/DXR.axd",
      "https://insight.adsrvr.org/track/conv/",
      "https://insight.adsrvr.org/track/evnt/",
      "https://kds-pixel.kargo.com/api/v1/track",
      "https://lax1-ib.adnxs.com",
      "https://lciapi.ninthdecimal.com/v1/lci/imp/adv-smg/c-22568",
      "https://login.dotomi.com/ucm/UCMController?dtm_com=28&dtm_cid=62624&dtm_cmagic=c4a3e7&dtm_fid=101&dtm_format=6&cli_promo_id=1",
      "https://lowes.netmng.com/pixel/",
      "https://match.adsrvr.org/track/cmf/generic",
      "https://nbcu.demdex.net/event",
      "https://new-collect.albacross.com/e.gif?s=STRING_ID&e0=EVENT&ci0=GUID&v0=GUID&p0=GUID&u0=GUID&c0=NUMBER&t0=NUMBER&ti0=HUGE_STRING&r0=URL",
      "https://nyl.as/open/STRING?cache_buster=TIMESTAMP",
      "https://nym1-ib.adnxs.com",
      "https://p.rfihub.com/cm",
      "https://pagead2.googlesyndication.com/pagead/gen_204",
      "https://partner.mediawallahscript.com/",
      "https://pippio.com/api/sync",
      "https://pixel-geo.prfct.co/cs/",
      "https://pixel-geo.prfct.co/seg/",
      "https://pixel.clutter.com/wt/track.gif",
      "https://pixel.locker2.com/image/xyz123.png?cb=123456789",
      "https://pixel.rubiconproject.com/tap.php",
      "https://pixel.tapad.com/idsync/ex/receive",
      "https://pl.yext.com/plpixel",
      "https://pubads.g.doubleclick.net/activity;xsp=123;qty=123;cost=123.00;ord=12345678",
      "https://px.ads.linkedin.com/collect/",
      "https://px.marchex.io/pixel.gif?p=7V-2lR",
      "https://px.owneriq.net/eucm/p/sig",
      "https://q.quora.com/_/ad/2fb7f6bfadef42d8b1cc2b49a3438b81/pixel",
      "https://r.turn.com/r/beacon",
      "https://rp.liadm.com/p?aid=a-02x8",
      "https://s-vop.sundaysky.com/t/v1/img?a=CUSTOMER_STRING&cb=ID&s=NUMBER",
      "https://s.amazon-adsystem.com/iui3",
      "https://s.ml-attr.com/getuid?https%3a%2f%2fattr.ml-api.io%2f%3fdomain%3dvsp.com%26pId%3d%24UID",
      "https://saffron.760main.com/atc/cvi",
      "https://saffron.760main.com/atc/ofi",
      "https://saffron.760main.com/atc/pgi",
      "https://saffron.760main.com/imp",
      "https://sb.scorecardresearch.com/p",
      "https://secure.converto.com/img/bh.gif?n=ID&g=NUMBER&a=NUMBER&s=NUMBER&l=NUMBER&t=STRING&f=NUMBER",
      "https://secure.media6degrees.com/orbserv/hbpix",
      "https://securepubads.g.doubleclick.net/pcs/view",
      "https://segment.prod.bidr.io/associate-segment",
      "https://servedby.flashtalking.com/spot/1/10376;90692;9350/",
      "https://servedby.flashtalking.com/spot/1/10376;90693;9350/",
      "https://servedby.flashtalking.com/spot/1/10376;90695;9350/",
      "https://servedby.flashtalking.com/spot/1/10376;90699;9350/?spotName=NAME&ftXName=&ftXNumItems=0&ftXRef=&ftXType=&ftXValue=VALUE&U2=12345&U3=12345&U4=&U6=0&U7=&U11=&U12=undefined&cachebuster=NUMBER",
      "https://sp.analytics.yahoo.com/spp.pl",
      "https://srv.stackadapt.com/rt?sid=fL3fWDJRuo-eZMVvvfHVvw&url=https%3A%2F%2Fwww.womply.com%2Fppp-ic-firstdraw%2F&t=PPP%20IC%20Firstdraw",
      "https://starman.fathomdns.com/?p=/share/secret/secret&h=https://app.usefathom.com&r=&nv=0&sid=SECRET&res=1440x900&tz=America/New_York&r2=null",
      "https://stats.g.doubleclick.net/r/collect?t=dc&aip=1&_r=3&v=1",
      "https://t.co/i/adsct",
      "https://t.co/1/i/adsct",
      "https://t.indeed.com/fullstory/log?url=https%3A%2F%2Fresumes.indeed.com%2Fsearch&bytesSentToFs=1056&requestsSentToFs=1&globalFsOrg=FSGlobal&existingFsOrg=FSGlobal",
      "https://t.myvisualiq.net/activity_pixel",
      "https://t.teads.tv/track",
      "https://t.wepay.com/fp/clear.png?org_id=ncwzrc4k&session_id=68268f59-ccd7-4249-9172-fdeaaf9c7e95&m=2",
      "https://tag.rmp.rakuten.com",
      "https://tags.bluekai.com/site/13209",
      "https://tags.w55c.net/rs?id=f031cc9668df491284d00fc893946a52&t=completed_view",
      "https://tapestry.tapad.com/tapestry/1",
      "https://tbc.scene7.com/is/image/TBCCorporation/kat-blank?fmt=png",
      "https://test.d.aa.online-metrix.net",
      "https://track.customer.io/events/page.gif",
      "https://track.hubspot.com/__ptq.gif?k=1&sd=1600x900",
      "https://track.linksynergy.com",
      "https://tracking.g2crowd.com/attribution_tracking/conversions/3952.gif?e=",
      "https://trackingapi.trendemon.com/api/events/pageview?accountId=ID&url=URL&cookie=ID&referral=URL&vid=ID&r=NUMBER",
      "https://trk.clinch.co/sync",
      "https://trkn.us/pixel/c",
      "https://urldefense.com/v3/__https://gwmtracking.com/p/v/1/5fsecret/format/img?__;!!NSECRET",
      "https://urldefense.proofpoint.com/v2/url",
      "https://vidassets.terminus.services/GUID/t.gif?d=GUID&s=GUID&p=URL&cb=ID",
      "https://widget.criteo.com/event",
      "https://widgets.magasins.labaie.com/cookies/render?data=STRING&cachebuster=NUMBER",
      "https://widgets.stores.saks.com/cookies/render",
      "https://widgets.stores.saksfifthavenue.com/cookies/render?data=DATA&cachebuster=NUMBER",
      "https://widgets.stores.thebay.com/cookies/render",
      "https://www.adelixir.com",
      "https://www.biglots.com/profile/set/fpc/px?dtm_cid=62602&dtm_cmagic=eba12c&ver=2&dtm_form_uid=<UNIQUE_HASH>&dtm_token=<UNIQUE_HASH>",
      "https://www.facebook.com/tr",
      "https://www.facebook.com/tr/",
      "https://www.fmpilot2.com/DXR.axd",
      "https://www.google-analytics.com/collect",
      "https://www.google.co.th/pagead/1p-user-list/803",
      "https://www.google.com/pagead/1p-user-list/803",
      "https://www.googletagmanager.com/a?id=GTM-M4",
      "https://www.gracobaby.com/proxydirectory/tags/images/undefined/11033/seteventid.png?hasConsent=true&cjConsent=MHxOfDB8Tnww",
      "https://www.linkedin.com/csp/cat",
      "https://www.marmot.com/proxydirectory/tags/images/undefined/11050/seteventid.png?hasConsent=true&cjConsent=MHxOfDB8Tnww",
      "https://www.ojrq.net/p/",
      "https://www.rev.com/Content/curve/img/one-pixel.png?v=F46760303A9FA4249F88575DBF94E48F",
      "https://www.thezebra.com/be/i/t/",
      "https://www18.officedepot.com/eluminate",
      "https://x.bidswitch.net/sync",
      "safari-extension://asdasdasdasdaasd",
      "https://forms.storefrontloans.com/lead/pixel/?main_key=B66EN&_tracking=1&_back=0&_t=1519938955636",
      "https://forms.storefrontloans.com/personal/lead/pixel/?main_key=nrpcw&_tracking=1&_back=0&_t=1519940879977",
      "https://forms.storefrontloans.com/lead/pixel/?main_key=bGkOt&_tracking=1&_back=0&_t=1519940946264",
      "https://forms.storefrontloans.com/car/lead/pixel/?main_key=lxQUX&_tracking=1&_back=0&_t=1519940987240",
      "http://image.apartmentguide.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "http://image1.apartmentguide.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "http://image.rent.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "http://image1.rent.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "http://image.rentals.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "http://image1.rentals.com/imgr/1269cf346bf0557066ab65e19aa1667e/-900",
      "https://www.globalgiving.org/pfil/dingdongding.png",
      "https://flightdeck.staples.com/styles/img/blank.gif",
      "http://imgs.signifyd.com//fp/clear.png?org_id=w2txo5aa&session_id=0000otc9crowqhybd_po4kmfilo19co4hp0o&ck=0&m=2&nonce=a89c6d055bb6eb17",
      "https://px.a8.net/a8fly/earnings?pid=s00000019111001&so=888880223&si=9800-1-9800-47&currency=JPY&type=image",
      "https://ps.mythirtyone.com/31Designer/tools/GetTemplatePreview2?templatecode=PERS_Airplane&OrderType=embroidery-template&sizeId=3&sessionId=18-1116-0658-29-157159",
      "https://telem.highlow.net/fp/tags.js?org_id=7nwhwds3&session_id=fs_testing",
      "https://telem.highlow.net/tags?org_id=7nwhwds3&session_id=fs_testing",
      "https://shareasale.com/sale.cfm?tracking=OrderID&amount=AA.BB&merchantID=XXXXX&transtype=sale",
      "https://www.shareasale.com/sale.cfm?tracking=OrderID&amount=AA.BB&merchantID=XXXXX&transtype=sale",
      "https://shareasale-analytics.com/j.js",
      "https://www.shareasale-analytics.com/j.js",
      "https://shareasale-analytics.com/sale.cfm",
      "https://www.shareasale-analytics.com/sale.cfm",
      "https://nova.collect.igodigital.com/c2/XXXXXX/track_page_view?payload=XXXXXX",
      "https://webanalytics.lexisnexis.com/wa_pag.watag?un=XXXX&lnbg=XXXX&lnmksc=XX&lnpmkc=23&lnsmkc=XX",
      "https://zoudlogick.net/metric/?mid=&wid=XXX&sid=&tid=XXX&rid=XXX&custom1=XXX",
      "https://px.owneriq.net/ep?sidXXX&jcs=XXX",
      "https://www.justfly.com/checkout/get-profiling-tags",
      "https://abcdef.d.aa.online-metrix.net/fp/clear.png?org_id=123456",
      "https://abcdef.dc-storm.com/t?tp=abc&sid=123&uid=123",
      "https://abcdef.micpn.com/p/cp/-1/track.gif?t=123&mi_u=456&mi_cid=789",
      "https://action.dstillery.com/orbserv/nspix?adv=cl1028900&ns=4945&nc=EcommStartKit&ncv=56&dstOrderId=[OrderId]&dstOrderAmount=[OrderAmount]",
      "https://ad.360yield.com/match?publisher_dsp_id=111&external_user_id=abcdef",
      "https://ade.clmbtech.com/uid/sync.htm?pid=123456&cuid=abcdef",
      "https://ads.scorecardresearch.com/b?c1=1&c2=123&c3=1&cs_xi=abcdef",
      "https://ads.sparkflow.net/e/?i=123,123&uid=abcdef&v=111&e=abc,,&x=123456",
      "https://ads.undertone.com/l?bannerid=12345&campaignid=12345",
      "https://ads.yahoo.com/cms/v1?esig=123456",
      "https://ads.yieldmo.com/v000/sync?pn_id=abcdef&id=123456",
      "https://app.eu.pendo.io/data/debuglog.gif",
      "https://app.eu.pendo.io/data/guide.gif",
      "https://app.eu.pendo.io/data/log.gif",
      "https://app.eu.pendo.io/data/poll.gif",
      "https://app.eu.pendo.io/data/ptm.gif",
      "https://app.eu.pendo.io/data/super.gif",
      "https://app.eu.pendo.io/data/xhr.gif",
      "https://app.pendo.io/data/debuglog.gif",
      "https://app.pendo.io/data/guide.gif",
      "https://app.pendo.io/data/guide.gif/123456",
      "https://app.pendo.io/data/log.gif",
      "https://app.pendo.io/data/poll.gif",
      "https://app.pendo.io/data/poll.gif/123456",
      "https://app.pendo.io/data/ptm.gif",
      "https://app.pendo.io/data/ptm.gif/123456",
      "https://app.pendo.io/data/super.gif",
      "https://app.pendo.io/data/xhr.gif",
      "https://beacon.krxd.net/usermatch.gif?partner=foo&partner_uid=abc",
      "https://book.jetblue.com/B6/pictures/misc/bg-total-price-separator.gif?version=202011052244",
      "https://book.jetblue.com/B6/pictures/misc/form_sep.gif?version=202011052244",
      "https://book.jetblue.com/B6/pictures/misc/true-blue-block-sep.gif?version=202011052244",
      "https://book.jetblue.com/B6/pictures/misc/x.gif?version=202011052244",
      "https://cdn-us-ec.yottaa.net/5b9fc7760b534475fab84de5/www.gnc.com/v~4b.35/on/demandware.static/-/Sites-GNC2-Library/default/v1585821485238/content-pages/misctrans2.png?yocs=s_4_",
      "https://cm.everesttech.net/cm/dd?d_uuid=123456",
      "https://consent.linksynergy.com/consent/v2/p?rmch=abc&tp=gdpr",
      "https://cw.addthis.com/t.gif?pid=123&pdid=456",
      "https://data.eu.pendo.io/data/debuglog.gif",
      "https://data.eu.pendo.io/data/guide.gif",
      "https://data.eu.pendo.io/data/log.gif",
      "https://data.eu.pendo.io/data/poll.gif",
      "https://data.eu.pendo.io/data/ptm.gif",
      "https://data.eu.pendo.io/data/super.gif",
      "https://data.eu.pendo.io/data/xhr.gif",
      "https://data.pendo.io/data/debuglog.gif",
      "https://data.pendo.io/data/guide.gif",
      "https://data.pendo.io/data/log.gif",
      "https://data.pendo.io/data/poll.gif",
      "https://data.pendo.io/data/ptm.gif",
      "https://data.pendo.io/data/ptm.gif/abcdef",
      "https://data.pendo.io/data/super.gif",
      "https://data.pendo.io/data/xhr.gif",
      "https://dp.shoprunner.com/i?stm=123456&e=aa&se_ca=SSO&se_ac=check",
      "https://dpm.demdex.net/ibs:dpid=123456&dpuuid=abcdef",
      "https://eb2.3lift.com/xuid?mid=123456&xuid=abcdef",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-Black.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-BlackItalic.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-Bold.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-BoldItalic.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-Italic.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-Medium.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-MediumItalic.woff2",
      "https://edgepro.gatewaypn.com/fonts/inter/Inter-UI-Regular.woff2",
      "https://edgepro.gatewaypn.com/images/ui-icons_444444_256x240.png",
      "https://edgepro.gatewaypn.com/images/ui-icons_555555_256x240.png",
      "https://edgepro.gatewaypn.com/images/ui-icons_777620_256x240.png",
      "https://edgepro.gatewaypn.com/images/ui-icons_cc0000_256x240.png",
      "https://edgepro.gatewaypn.com/images/ui-icons_ffffff_256x240.png",
      "https://fyf.tac-cdn.net/images/layout/nav_7_on.png?auto=webp&quality=10",
      "https://fyf.tac-cdn.net/images/layout_320/nav_2_off.png?auto=webp&quality=10",
      "https://gum.criteo.com/sync?c=123&r=1&a=1",
      "https://heapanalytics.com/h?a=1227582568&u=8363349893243617&v=6526124775316058&s=3373732743171606&b=web&tv=4.0&sp=r&sp=https%3A%2F%2Fwww.google.com%2F&sp=us&sp=semgb&sp=um&sp=paid&sp=ut&sp=toast%20pos&sp=ua&sp=tpos-b2bsmb-paid-59931782856-exabrandxx-acq-semgb-cousa_wmql&sp=ts&sp=1602781924917&sp=d&sp=pos.toasttab.com&sp=h&sp=%2Fpricing&sp=q&sp=%3Fsource%3Dtpos_acq_paidxxx_cousa_semgb_wmql_exabrandxx%26utm_medium%3Dpaid%26utm_source%3Dsemgb%26utm_campaign%3Dtpos-b2bsmb-paid-59931782856-exabrandxx-acq-semgb-cousa_wmql%26utm_term%3Dtoast%2520pos%26_bt%3D430077985352%26_bm%3De%26_bn%3Dg%26gclid%3DCjwKCAjw5p_8BRBUEiwAPpJO60j0U14mW7RrxZlX9j4PwM7LK-SvJhl-AiMWUbfQ4bcuI47PV3H_yBoCRFsQAvD_BwE&pp=d&pp=pos.toasttab.com&pp=h&pp=%2Fshop%2Fstarter-kit%2F&pp=t&pp=Shop%20%7C%20Toast%20POS&pp=ts&pp=1602781961851&pp=pr&pp=%2Fpricing&id0=4608782718144270&k0=Drift%20Conversation%20ID&k0=2653752097&t0=drift%20message",
      "https://i.liadm.com/s/123456?bidder_id=123456",
      "https://manage.rewardsgenius.com/font/proximanova-light-webfont.eot",
      "https://manage.rewardsgenius.com/font/proximanova-light-webfont.eot?",
      "https://manage.rewardsgenius.com/font/proximanova-light-webfont.svg",
      "https://manage.rewardsgenius.com/font/proximanova-light-webfont.woff2",
      "https://manage.rewardsgenius.com/font/proximanova-lightitalic-webfont.eot",
      "https://manage.rewardsgenius.com/font/proximanova-lightitalic-webfont.svg",
      "https://manage.rewardsgenius.com/font/proximanova-lightitalic-webfont.ttf",
      "https://manage.rewardsgenius.com/font/proximanova-lightitalic-webfont.woff",
      "https://manage.rewardsgenius.com/font/proximanova-reg-webfont.eot?",
      "https://manage.rewardsgenius.com/font/proximanova-reg-webfont.ttf",
      "https://manage.rewardsgenius.com/font/proximanova-reg-webfont.woff2",
      "https://manage.rewardsgenius.com/font/proximanova-regit-webfont.ttf",
      "https://manage.rewardsgenius.com/font/proximanova-regit-webfont.woff",
      "https://manage.rewardsgenius.com/font/proximanova-regit-webfont.woff2",
      "https://manage.rewardsgenius.com/font/proximanova-sbold-webfont.eot",
      "https://manage.rewardsgenius.com/font/proximanova-sbold-webfont.eot?",
      "https://manage.rewardsgenius.com/font/proximanova-sbold-webfont.ttf",
      "https://manage.rewardsgenius.com/font/proximanova-sbold-webfont.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-Black.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-BlackItalic.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-Bold.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-BoldItalic.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-Italic.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-Medium.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-MediumItalic.woff2",
      "https://manage.rewardsgenius.com/fonts/inter/Inter-UI-Regular.woff2",
      "https://manage.rewardsgenius.com/fonts/materialdesignicons-webfont.541e65fb.eot",
      "https://manage.rewardsgenius.com/fonts/materialdesignicons-webfont.541e65fb.eot?",
      "https://manage.rewardsgenius.com/fonts/materialdesignicons-webfont.c61b9c12.woff2",
      "https://manage.rewardsgenius.com/fonts/materialdesignicons-webfont.fc03f7f1.ttf",
      "https://manage.rewardsgenius.com/fonts/materialdesignicons-webfont.ff13d121.woff",
      "https://manage.rewardsgenius.com/fonts/tc-icons.0232cd03.woff",
      "https://manage.rewardsgenius.com/fonts/tc-icons.1a55d62b.eot?",
      "https://manage.rewardsgenius.com/fonts/tc-icons.954c6c03.ttf",
      "https://manage.rewardsgenius.com/fonts/tc-icons.f376e922.woff2",
      "https://nexus.ensighten.com/abcdef/prod/TagAuditBeacon.rnc?cid=123",
      "https://nexus.ensighten.com/abcdef/prod/perf.rnc?cid=123",
      "https://ping.chartbeat.net/ping?h=foo.com&p=bar",
      "https://pixel.advertising.com/ups/123456/sync?uid=abcdef",
      "https://pixel.mathtag.com/misc/img?aabbcc&bcdv=1",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Bold.eot",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Bold.eot?",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Bold.ttf",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Bold.woff",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Italic.eot",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Italic.eot?",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Italic.ttf",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Italic.woff",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Roman.eot",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Roman.eot?",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Roman.ttf",
      "https://pt-static.nationwide.com/fonts/ChronicleTextG1-Roman.woff",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Bold_gdi.eot",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Bold_gdi.eot?",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Bold_gdi.svg",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Bold_gdi.ttf",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Bold_gdi.woff",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Light_gdi.eot",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Light_gdi.eot?",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Light_gdi.svg",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Light_gdi.ttf",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Light_gdi.woff",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Regular_gdi.eot",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Regular_gdi.eot?",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Regular_gdi.svg",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Regular_gdi.ttf",
      "https://pt-static.nationwide.com/fonts/ProximaNova-Regular_gdi.woff",
      "https://pt-static.nationwide.com/media/bolt-icons.svg?r=9",
      "https://pt-static.nationwide.com/media/bolt-icons.ttf?r=9",
      "https://pt-static.nationwide.com/media/bolt-icons.woff?r=9",
      "https://pt.ispot.tv/v2/TC-3374-1.gif?app=web&type=GTM_VDP",
      "https://px.ads.linkedin.com/collect?v=2&fmt=js&pid=410489&url=https%3A%2F%2Fpos.toasttab.com%2Fshop%2Fstarter-kit%2F&time=1602781962522",
      "https://px0.pbbl.co/ns/__p2.gif?ppid=123456",
      "https://r.casalemedia.com/rum?cm_dsp_id=123&external_user_id=abcdef",
      "https://rt3015.infolinks.com/action/adview.htm?rid=123456&bdc=0&midx=0&emd=123456",
      "https://rtb-csync.smartadserver.com/redir/?partnerid=123&partneruserid=abcdef",
      "https://securepubads.g.doubleclick.net/pcs/view?xai=abcdef",
      "https://simage2.pubmatic.com/AdServer/Pug?vcode=abcdef",
      "https://ssp.meba.kr/cm.mezzo/?buyerid=abcdef",
      "https://static.nationwide.com/app/clicktochat/application/version/pie_files/PIE.htc",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Bold.eot",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Bold.eot?",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Bold.ttf",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Bold.woff",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Italic.eot",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Italic.eot?",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Italic.ttf",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Italic.woff",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Roman.eot",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Roman.eot?",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Roman.ttf",
      "https://static.nationwide.com/fonts/ChronicleTextG1-Roman.woff",
      "https://static.nationwide.com/fonts/ProximaNova-Bold_gdi.eot",
      "https://static.nationwide.com/fonts/ProximaNova-Bold_gdi.eot?",
      "https://static.nationwide.com/fonts/ProximaNova-Bold_gdi.svg",
      "https://static.nationwide.com/fonts/ProximaNova-Bold_gdi.ttf",
      "https://static.nationwide.com/fonts/ProximaNova-Bold_gdi.woff",
      "https://static.nationwide.com/fonts/ProximaNova-Light_gdi.eot",
      "https://static.nationwide.com/fonts/ProximaNova-Light_gdi.eot?",
      "https://static.nationwide.com/fonts/ProximaNova-Light_gdi.svg",
      "https://static.nationwide.com/fonts/ProximaNova-Light_gdi.ttf",
      "https://static.nationwide.com/fonts/ProximaNova-Light_gdi.woff",
      "https://static.nationwide.com/fonts/ProximaNova-Regular_gdi.eot",
      "https://static.nationwide.com/fonts/ProximaNova-Regular_gdi.eot?",
      "https://static.nationwide.com/fonts/ProximaNova-Regular_gdi.svg",
      "https://static.nationwide.com/fonts/ProximaNova-Regular_gdi.ttf",
      "https://static.nationwide.com/fonts/ProximaNova-Regular_gdi.woff",
      "https://static.nationwide.com/media/bolt-icons.eot?r=4",
      "https://static.nationwide.com/media/bolt-icons.eot?r=6",
      "https://static.nationwide.com/media/bolt-icons.ttf?r=4",
      "https://static.nationwide.com/media/bolt-icons.ttf?r=6",
      "https://static.nationwide.com/media/bolt-icons.woff?r=6",
      "https://sync-criteo.ads.yieldmo.com/sync?id=abcdef",
      "https://sync.aralego.com/idSync/?ucf_nid=abcdef",
      "https://sync.e-planning.net/um?uid=abcdef",
      "https://sync.outbrain.com/cookie-sync?p=abcdef&uid=abcdef",
      "https://tags.bluekai.com/site/12345?id=12345",
      "https://udc-neb.kampyle.com/egw/5/abcdef/track/__cool.gif?data=abcdef",
      "https://us-u.openx.net/w/1.0/cm?id=abcdef",
      "https://ut.ra.linksynergy.com/t?tp=abc&so=def&sid=123&uid=456",
      "https://www.google-analytics.com/r/collect?v=1&_v=2&a=3&t=event&_s=1",
      "https://www.google.com/ads/ga-audiences?t=sr&aip=1&_r=4&slf_rd=1&v=1&_v=j86&tid=UA-58064552-1&cid=1988039941.1602781924&jid=2018928939&_u=SDCAAEADQAAAgC~&z=1278516506",
      "https://www.google.com/ads/measurement/l?ebcid=ABCDEF",
      "https://cds.taboola.com/?uid=123456&_r=123456",
      "https://cdn.taboola.com/libtrc/tr5?abgroup=abcdef",
      "https://la-vid-events.taboola.com/st?cijs=asasdfadsf&ttype=123&cisd=adfasdf&cipid=123123",
      "https://trc.taboola.com/sg/criteortb-network/1/rtb-h/?taboola_hm=123abc",
      "https://deviceprotection.phoneclaim.com/assets/fonts/glyphicons-halflings-regular.eot?",
      "https://deviceprotection.phoneclaim.com/stylesheets/fonts/icomoon.eot",
      "https://deviceprotection.phoneclaim.com/stylesheets/fonts/Sprint%20Sans%20Web-Black.eot",
      "https://ff.kis.v2.scr.kaspersky-labs.com/E3E8934C-235A-4B0E-825A-35A08381A191/abn/main.css?attr=aHR0cHM6Ly93d3cubWFjeXMuY29tL3Nob3AvcHJvZHVjdC8xMi1kYXlzLW9mLXNwYXJrbGUtaG9sb2dyYW0tY2FsZW5kYXI_SUQ9MTI5MTc2ODImQ2F0ZWdvcnlJRD05MTYwNQ",
      "https://www.example.com/$%7BSBExtension.browserInject.getURL%28%22img/coupon-injection/oops.jpg%22%29%7D",
      "http://auth.grin.co/u/login/identifier",
      "https://edgepro.gatewaypn.com/font/proximanova-lightitalic-webfont.eot",
      "https://edgepro.gatewaypn.com/font/proximanova-lightitalic-webfont.svg",
      "https://edgepro.gatewaypn.com/font/proximanova-lightitalic-webfont.ttf",
      "https://edgepro.gatewaypn.com/font/proximanova-lightitalic-webfont.woff",
      "https://edgepro.gatewaypn.com/font/proximanova-lightitalic-webfont.woff2",
      "https://edgepro.gatewaypn.com/font/proximanova-reg-webfont.eot",
      "https://edgepro.gatewaypn.com/font/proximanova-reg-webfont.svg",
      "https://edgepro.gatewaypn.com/font/proximanova-reg-webfont.ttf",
      "https://edgepro.gatewaypn.com/font/proximanova-reg-webfont.woff",
      "https://edgepro.gatewaypn.com/font/proximanova-reg-webfont.woff2",
      "https://edgepro.gatewaypn.com/font/proximanova-regit-webfont.eot",
      "https://edgepro.gatewaypn.com/font/proximanova-regit-webfont.svg",
      "https://edgepro.gatewaypn.com/font/proximanova-regit-webfont.ttf",
      "https://edgepro.gatewaypn.com/font/proximanova-regit-webfont.woff",
      "https://edgepro.gatewaypn.com/font/proximanova-regit-webfont.woff2",
      "https://edgepro.gatewaypn.com/font/proximanova-sbold-webfont.eot",
      "https://edgepro.gatewaypn.com/font/proximanova-sbold-webfont.svg",
      "https://edgepro.gatewaypn.com/font/proximanova-sbold-webfont.ttf",
      "https://edgepro.gatewaypn.com/font/proximanova-sbold-webfont.woff",
      "https://edgepro.gatewaypn.com/font/proximanova-sbold-webfont.woff2",
      "https://edgepro.gatewaypn.com/font/proximanova-light-webfont.eot",
      "https://edgepro.gatewaypn.com/font/proximanova-light-webfont.svg",
      "https://edgepro.gatewaypn.com/font/proximanova-light-webfont.ttf",
      "https://edgepro.gatewaypn.com/font/proximanova-light-webfont.woff",
      "https://edgepro.gatewaypn.com/font/proximanova-light-webfont.woff2",
      "https://edgepro.gatewaypn.com/assets/images/arrow-dark-mode.png",
      "https://edgepro.gatewaypn.com/assets/images/arrow-light-mode.png",
      "https://edgepro.gatewaypn.com/assets/images/arrow-light-mode-up.png",
      "https://edgepro.gatewaypn.com/assets/images/circle_2.svg",
      "https://edgepro.gatewaypn.com/assets/images/x.png",
      "https://edgepro.gatewaypn.com/assets/images/arrow-dark-mode-up.png",
      "https://edgepro.gatewaypn.com/assets/images/loading.gif",
      "https://edgepro.gatewaypn.com/assets/images/clockify_logo_dark.svg",
      "https://edgepro.gatewaypn.com/assets/images/circle_1.svg",
      "https://secure-www.gapcanada.ca/shopping-bag?_gl=1*zbzlep*_gcl_au*NjI5ODQyMjUwLjE3Mjk1MTU1MTU.",
      "https://fs.invalid/test#testHash",
      "https://fs.invalid/test?withQs#withHash"
    ],
    "localFallback": [
      "http://localhost:8080",
      "https://cdn.bibliu.com/",
      "https://bibliu.com/books/some/other/path",
      "https://random-subdomain.bibliu.com/books/a/b/c/d",
      "https://bibliotech.com/books/",
      "https://sub.bibliotech.com/books/x/y/z",
      "https://bibliotech.education/books/1/2/3",
      "https://domain.bibliotech.education/books/",
      "https://www.invoicecloud.com/portal/(S(bzko02e5nzj22rurkj2agavs))/2/resources/plugins/fonts/googleFonts.css",
      "https://www.invoicecloud.com/portal/(S(cxvegmfaulr041xgvzgrvo4v))/2/resources/plugins/datepicker/datepicker.min.css",
      "https://www.invoicecloud.com/portal/(S(lblk20zmbaf15uidvfflhmra)/2/resources/plugins/bootstrap/bootstrap.css",
      "https://www.invoicecloud.com/portal/(S(oyrpn1tfsgxnnxfctd0rw3hj)/branding/themes/ICBlue/themeStyle.css",
      "https://www.invoicecloud.com/portal/(S(cxvegmfaulr041xgvzgrvo4v)/2/resources/css/ic-client-validation-ADA.css",
      "https://www.invoicecloud.com/portal/(S(2l2s4gak0x1afiosm4kqaw3n)/2/resources/plugins/datatables/buttons.dataTables.min.css",
      "https://delivery.panerabread.com/fonts/dynamics_icon_7213f0ba7419d6ff00172ba60b781eda.ttf",
      "https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-light.woff",
      "https://www-beta.panerabread.com/content/dam/panerabread/static/fonts/archer/Archer-Bold.eot",
      "https://www-beta.panerabread.com/fonts/inter/Inter-UI-Black.woff2",
      "https://www.panerabread.com/fonts/inter/Inter-UI-Black.woff2",
      "https://cdn.f.thread.com/medialibrary/2021/07/header_06_07_2021_Your%20holiday%20capsule%20wardrobe.jpg.07d02e37-609e-4b40-9ea0-c305c517b8f7.jpg?fit=bounds&quality=80&width=330",
      "https://images.gcp.thread.com/medialibrary/2021/07/header_06_07_2021_Your%20holiday%20capsule%20wardrobe.jpg.07d02e37-609e-4b40-9ea0-c305c517b8f7.jpg?fit=bounds&quality=80&width=330",
      "https://storage.thread.com/medialibrary/2021/07/header_06_07_2021_Your%20holiday%20capsule%20wardrobe.jpg.07d02e37-609e-4b40-9ea0-c305c517b8f7.jpg?fit=bounds&quality=80&width=330",
      "https://static.thread.com/medialibrary/2021/07/header_06_07_2021_Your%20holiday%20capsule%20wardrobe.jpg.07d02e37-609e-4b40-9ea0-c305c517b8f7.jpg?fit=bounds&quality=80&width=330"
    ],
    "proxy": [
      "https://drscdn.org.500px/photo/big-image.png"
    ],
    "cache": [
      "http://happyfeet.not.blocklisted.com",
      "https://www.google.com",
      "https://google.com",
      "https://www.seewhy.com/",
      "https://www.online-metrix.net/",
      "https://d3accju1t3mngt.cloudfront.net/some/other/path",
      "http://d3accju1t3mngt.cloudfront.net/some/other/path"
    ]
  }
}
